
import React, { useEffect, useState } from "react";
import Button from "../../components/ui/Button";
import Heading from "../../components/ui/Heading";
import api from "../../api/api";
import { useAuth } from "../../context/AuthContext";

function Counter() {
  const { user } = useAuth();
  const [godowns, setGodowns] = useState([]);
  const [selectedGdId, setSelectedGdId] = useState("");

  useEffect(() => {
    async function fetchGodowns() {
      try {
        const usrId = user?.UsrId;
        if (!usrId) return;

        const res = await api.CompanyDetails(usrId);
        const data = res?.Table1 || [];
        setGodowns(data);

        let savedGdId = sessionStorage.getItem("gdid");

        if (savedGdId && data.some((g) => g.GdId.toString() === savedGdId)) {
          setSelectedGdId(savedGdId);
        } else if (data.length > 0) {
          const gd1 = data.find((g) => g.GdId.toString() === "1");
          const defaultGdId = gd1 ? gd1.GdId.toString() : data[0].GdId.toString();

          setSelectedGdId(defaultGdId);
         sessionStorage.setItem("godowns", JSON.stringify(data));
          sessionStorage.setItem(
            "gdname",
            data.find((g) => g.GdId.toString() === defaultGdId)?.GodownName || ""
          );
        } else {
          setSelectedGdId("");
        }
      } catch (err) {
        console.error("Error fetching godowns:", err);
      }
    }

    fetchGodowns();
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedGdId) {
      alert("Please select a godown");
      return;
    }

    try {
      const payload = {
        Usrid: user?.UsrId,
        gdid: Number(selectedGdId),
      };

      console.log("Submitting payload:", payload);
      const res = await api.UserGodownLogin(payload);
      console.log("API Response:", res);

      // ✅ Store gdid + name in sessionStorage
      sessionStorage.setItem("gdid", selectedGdId);
      const selectedGodown = godowns.find(
        (g) => g.GdId.toString() === selectedGdId
      );
      if (selectedGodown) {
        sessionStorage.setItem("gdname", selectedGodown.GodownName);
      }

      // ✅ Trigger sidebar update
      window.dispatchEvent(new Event("godownChanged"));

      alert("Godown login successful!");
      // window.location.href = "/dashboard"; 
    } catch (error) {
      console.error("Error submitting godown login:", error);
      alert("Failed to login godown");
    }
  };

  return (
    <div className="max-w-md p-5 mx-auto mt-4 bg-white border rounded-lg shadow-sm border-slate-200">
      <Heading>Select Godown</Heading>

      <form className="space-y-4" onSubmit={handleSubmit}>
        <div>
          <label className="block mb-1 text-sm font-medium text-slate-600">Godown</label>
          <select
            value={selectedGdId}
            onChange={(e) => setSelectedGdId(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg border-slate-300 text-slate-700 focus:ring focus:ring-teal-200"
          >
            {godowns.map((g) => (
              <option key={g.GdId} value={g.GdId}>
                {g.GodownName}
              </option>
            ))}
          </select>
          <input type="hidden" name="GdId" value={selectedGdId} />
        </div>

        <Button type="submit" className="w-full">
          Submit
        </Button>
      </form>
    </div>
  );
}

export default Counter;
